import { memo } from 'react';

function OverViewIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.77777 6.11111V13.8889C3.77777 15.6071 6.56356 17 9.99999 17C13.4364 17 16.2222 15.6071 16.2222 13.8889V6.11111M3.77777 6.11111C3.77777 7.82933 6.56355 9.22222 9.99999 9.22222C13.4364 9.22222 16.2222 7.82933 16.2222 6.11111M3.77777 6.11111C3.77777 4.39289 6.56355 3 9.99999 3C13.4364 3 16.2222 4.39289 16.2222 6.11111M16.2222 10C16.2222 11.7182 13.4364 13.1111 9.99999 13.1111C6.56355 13.1111 3.77777 11.7182 3.77777 10"
        stroke="#3137B2"
        strokeWidth="1.67"
      />
    </svg>
  );
}

export default memo(OverViewIcon);
